import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { LOCAL__network_set_waiting_response } from '@/state/network/LOCAL__network_set_waiting_response';
import { store } from '@/state/store';
import { set_timeout } from '@/utils/utils_client';
import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_key_in_record } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { DTOPerformaceCapture } from '@shared/utils/performance/dto_performance_capture';
import { EPerformaceReferenceDuration } from '@shared/utils/performance/e_performance_reference';
import { get_size_in_bytes_number } from '@shared/utils/utils_files';
import { log_network_event, logi } from '@shared/utils/utils_logs';
import { create_performace_capture } from '@shared/utils/utils_performance';
import { CONSTANTS__client } from '../../constants/CONSTANTS__client';
import { ENUM__local_event } from '../events/ENUM__local_event';
import { service_local_events } from '../events/service_local_events';
import { service_socketio_client } from './service_socketio_client';

const { NETWORK_EVENTS_AUTOMATED } = CONSTANTS__shared;

export function try_log_client_to_server(event: string, data: any, log_entry_id: number) {
  if (!CONSTANTS__client.SERVICE_SOCKETIO_LOGGER_ENABLED) return;
  if (CONSTANTS__shared.NETWORK_EVENTS_AUTOMATED.includes(event)) return;

  let bytes = get_size_in_bytes_number(data);

  log_network_event('🖥️ c → s', event, bytes, {
    namespace: ELoggerNamespaceShared.CLIENT_TO_SERVER,
    client_id: CONSTANTS__client.LOGGER_USER_ID,
    connection_id: CONSTANTS__client.LOGGER_CONNECTION_ID,
    log_entry_id: service_socketio_client.outcoming_requests_number,
  });
}

export function try_log_server_to_request(event: string, data: any, performance_capture: DTOPerformaceCapture, log_entry_id: number) {
  if (!CONSTANTS__client.SERVICE_SOCKETIO_LOGGER_ENABLED) return;
  if (CONSTANTS__shared.NETWORK_EVENTS_AUTOMATED.includes(event)) return;

  let bytes = get_size_in_bytes_number(data);

  log_network_event('📩 s → r', event, bytes, {
    namespace: ELoggerNamespaceShared.SERVER_TO_CLIENT,
    client_id: CONSTANTS__client.LOGGER_USER_ID,
    connection_id: CONSTANTS__client.LOGGER_CONNECTION_ID,
    performance_capture,
    log_entry_id,
  });
}

export function send_to_server<T>(event: string, data: any = null): Promise<T> {
  if (data && Array.isArray(data)) {
    //do nothing
  } else if (data && typeof data == 'object') {
    assert_key_in_record(data, CONSTANTS__shared.SERIALIZATION_CLASS_FIELD_INSTANCE);
  }

  return new Promise((resolve, reject) => {
    const socket = service_socketio_client.socket;
    if (!socket) return reject(new Error('socket is not initialized'));
    if (!socket.connected) return reject(new Error('socket is not connected'));

    let performance_capture = create_performace_capture(event, EPerformaceReferenceDuration.RESPONSE_FROM_SERVER);

    let request_id = service_socketio_client.outcoming_requests_number;
    FN__waiting_for_response(event, request_id, true);

    let timeout_id = set_timeout(() => {
      if (!NETWORK_EVENTS_AUTOMATED.includes(event)) logi(`❌ response timeout\t${event}`);

      FN__waiting_for_response(event, request_id, false);

      resolve(new DTO_RESPONSE__error(ENUM__error_type.RESPONSE_TIMEOUT) as T);
    }, CONSTANTS__environment_client.VITE_SERVICE_ULTIMATEDIFFUSION_SOCKET_RESPONSE_TIMEOUT_NUMBER);

    socket.emit(event, data, (response: any, response_packed: Uint8Array, outcoming_requests_number: number) => {
      FN__waiting_for_response(event, request_id, false);

      clearTimeout(timeout_id);

      try_log_server_to_request(event, response_packed, performance_capture, outcoming_requests_number);

      if (response instanceof DTO_RESPONSE__error) {
        service_socketio_client.errors.push(response);

        service_local_events.emit(ENUM__local_event.RESPONSE_ERROR_RECEIVED);
      }

      resolve(response);
    });
  });
}

function FN__waiting_for_response(event: string, id: number, is_waiting: boolean) {
  if (NETWORK_EVENTS_AUTOMATED.includes(event)) return;

  store.dispatch(LOCAL__network_set_waiting_response({ id, is_waiting }));
}
